import * as React from "react";
import {
  Flex,
  IconButton,
  Link
} from "@chakra-ui/react";

import {
  Facebook,
  Google,
  Instagram
} from "../ScalableVectorGraphics";


export const Socials: React.FC = () => {
  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      gap="16px"
    >
      <IconButton
        aria-label="Facebook"
        as={ Link }
        href="https://www.facebook.com/DestinyRoofingCorp/"
        isExternal
        icon={ <Facebook /> }
        minW="32px"
        w={{
          base: '32px',
          lg: '40px'
        }}
        h={{
          base: '32px',
          lg: '40px'
        }}
        bg="transparent"
        border="1px"
        borderRadius="50%"
        borderColor="primary.900"
        color="primary.900"
        transition="all 0.3s ease-in-out"
        _hover={{
          bg: "primary.900",
          color: "white"
        }}
      />
      <IconButton
        aria-label="Instagram"
        as={ Link }
        href="https://www.instagram.com/destiny.roofing/"
        isExternal
        icon={ <Instagram /> }
        minW="32px"
        w={{
          base: '32px',
          lg: '40px'
        }}
        h={{
          base: '32px',
          lg: '40px'
        }}
        bg="transparent"
        border="1px"
        borderRadius="50%"
        borderColor="primary.900"
        color="primary.900"
        transition="all 0.3s ease-in-out"
        _hover={{
          bg: "primary.900",
          color: "white"
        }}
      />
      <IconButton
        aria-label="Google"
        as={ Link }
        href="https://goo.gl/maps/2Gje4shkFvnowYY88"
        isExternal
        icon={ <Google /> }
        minW="32px"
        w={{
          base: '32px',
          lg: '40px'
        }}
        h={{
          base: '32px',
          lg: '40px'
        }}
        bg="transparent"
        border="1px"
        borderRadius="50%"
        borderColor="primary.900"
        color="primary.900"
        transition="all 0.3s ease-in-out"
        _hover={{
          bg: "primary.900",
          color: "white"
        }}
      />
    </Flex>
  )
}
